import React, { useMemo } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { BlogLayout } from '../components/blog/BlogLayout';
import { PostBlock, PostHeader, PostTags, MorePosts } from '../components/blog/PostParts';
import { useSeo } from '../hooks/useSeo';
import { buildPostJsonLd } from '../utils/blogSeo';
import { BLOG_POSTS, findPost } from '../constants/blogPosts';

export default function BlogPostPage() {
  const { slug } = useParams();
  const post = findPost(slug);
  const jsonLd = useMemo(() => (post ? buildPostJsonLd(post) : null), [post]);
  useSeo({
    title: post ? `${post.title} | Jess Sells East Coast Blog` : 'Blog',
    description: post?.excerpt || '',
    path: `/blog/${slug}`,
    jsonLd,
  });

  if (!post) return <Navigate to="/blog" replace />;
  const more = BLOG_POSTS.filter((p) => p.slug !== post.slug).slice(0, 2);

  return (
    <BlogLayout backTo="/blog" backLabel="All posts">
      <article className="max-w-3xl mx-auto px-5 pt-8" data-testid="blog-post">
        <PostHeader post={post} />
        <div className="space-y-5 pt-8">
          {post.content.map((block, i) => <PostBlock key={`${block.type}-${i}`} block={block} post={post} />)}
        </div>
        <PostTags tags={post.tags} />
      </article>
      <MorePosts posts={more} />
    </BlogLayout>
  );
}
